// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeline-clickable {
  display: flex;
  align-items: center;
  height: 20px;
  width: 100%;
  margin: 7px 0; }
  .timeline-clickable__description {
    width: 100%; }
  .timeline-clickable_pointer {
    cursor: pointer; }
  .timeline-clickable_red {
    height: 100%;
    background-color: #e00606;
    position: relative; }
  .timeline-clickable_green {
    height: 100%;
    background-color: #87bc45; }
  .timeline-clickable_grey {
    height: 100%;
    background-color: #838383; }
  .timeline-clickable__container {
    width: calc(100% - 120px);
    height: 30px;
    background-color: #E0E0E0;
    display: flex;
    border-radius: 6px;
    overflow: hidden; }
  .timeline-clickable__text {
    width: 120px;
    font-weight: 600;
    font-size: 13px;
    text-align: center; }
  .timeline-clickable__line {
    margin: 5px 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e0e0e0; }
  .timeline-clickable__timezone {
    text-align: center;
    width: 100%;
    cursor: pointer; }
    .timeline-clickable__timezone:hover {
      color: #FE6100; }
  .timeline-clickable__zoomout {
    min-width: 120px;
    width: 120px;
    text-align: center;
    cursor: pointer; }
    .timeline-clickable__zoomout:hover {
      color: #FE6100; }

.timeline-hub-clickable {
  display: flex;
  flex-direction: column;
  gap: 10px; }
  .timeline-hub-clickable__container {
    background-color: white;
    padding: 5px;
    box-shadow: 0px 0px 8px rgba(42, 98, 149, 0.25);
    border-radius: 4px; }
  .timeline-hub-clickable__camera {
    display: flex;
    flex-direction: column;
    gap: 20px; }
`, "",{"version":3,"sources":["webpack://./src/pages/live/timeline/timeline.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa,EAAA;EACb;IACE,WAAW,EAAA;EAEb;IACE,eAAe,EAAA;EAEjB;IACE,YAAY;IACZ,yBAAyB;IACzB,kBAAkB,EAAA;EAEpB;IACE,YAAY;IACZ,yBAAyB,EAAA;EAE3B;IACE,YAAY;IACZ,yBAAyB,EAAA;EAE3B;IACE,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,gBAAgB,EAAA;EAElB;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB,EAAA;EAEpB;IACE,aAAa;IACb,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,gCAAgC,EAAA;EAElC;IACE,kBAAkB;IAClB,WAAW;IACX,eAAe,EAAA;IAHhB;MAKG,cAAc,EAAA;EAGlB;IACE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe,EAAA;IAJhB;MAMG,cAAc,EAAA;;AAIpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;EACT;IACE,uBAAuB;IACvB,YAAY;IACZ,+CAA+C;IAC/C,kBAAkB,EAAA;EAEpB;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS,EAAA","sourcesContent":[".timeline-clickable {\n  display: flex;\n  align-items: center;\n  height: 20px;\n  width: 100%;\n  margin: 7px 0;\n  &__description {\n    width: 100%;\n  }\n  &_pointer {\n    cursor: pointer;\n  }\n  &_red {\n    height: 100%;\n    background-color: #e00606;\n    position: relative;\n  }\n  &_green {\n    height: 100%;\n    background-color: #87bc45;\n  }\n  &_grey {\n    height: 100%;\n    background-color: #838383;\n  }\n  &__container {\n    width: calc(100% - 120px);\n    height: 30px;\n    background-color: #E0E0E0;;\n    display: flex;\n    border-radius: 6px;\n    overflow: hidden;\n  }\n  &__text {\n    width: 120px;\n    font-weight: 600;\n    font-size: 13px;\n    text-align: center;\n  }\n  &__line {\n    margin: 5px 0;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    border-bottom: 1px solid #e0e0e0;\n  }\n  &__timezone{\n    text-align: center;\n    width: 100%;\n    cursor: pointer;\n    &:hover{\n      color: #FE6100;\n    }\n  }\n  &__zoomout{\n    min-width: 120px;\n    width: 120px;\n    text-align: center;\n    cursor: pointer;\n    &:hover{\n      color: #FE6100;\n    }\n  }\n}\n.timeline-hub-clickable {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  &__container {\n    background-color: white;\n    padding: 5px;\n    box-shadow: 0px 0px 8px rgba(42, 98, 149, 0.25);\n    border-radius: 4px;\n  }\n  &__camera {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
